export default __webpack_public_path__ + "static/media/money.fa281e55.svg";